import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { axios } from 'modules/axios'

const getHosts = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<string[]>({
    method: 'GET',
    url: endpoints.cognitiveSettings.getHosts(),
  })
  return response
}

const getEndpoints = async (): GetArrayResponse<string> => {
  const { data: response } = await axios.request<string[]>({
    method: 'GET',
    url: endpoints.cognitiveSettings.getEndpoints(),
  })
  return response
}

export const cognitiveSettingsApi = {
  getHosts,
  getEndpoints,
}
